import { navigateLanguage, resolveLanguage } from "plos/src/utils/language";
import { bootstrapHeaderFooter } from "plos/src/utils/pulse/bootstrapHeaderFooter";

const language = resolveLanguage();
navigateLanguage(language);

bootstrapHeaderFooter({
  language,
  baseURL: import.meta.env.VITE_HF_BASE,
});
